import { defineComponent } from "vue";
import RoundCheckIcon from "@/assets/images/svg/white-round-check.svg";
export default defineComponent({
  name: "PromocodeCampaignExpandedCard",
  props: {
    data: {
      required: true,
      type: Object
    },
    toggleApplyPromocode: {
      type: Function,
      required: true
    }
  },
  setup: function setup(props) {
    var onToggleApplyPromocode = function onToggleApplyPromocode() {
      props.toggleApplyPromocode(props.data);
    };

    return {
      onToggleApplyPromocode: onToggleApplyPromocode,
      RoundCheckIcon: RoundCheckIcon
    };
  }
});